module.exports = __webpack_public_path__ + "assets/img/ma-logo-404ed2c8.png";